/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Header} from './Header'
import {Navbar} from './Navbar'

export function HeaderWrapper() {
  const {config, classes} = useLayout()
  if (!config.app?.header?.display) {
    return null
  }

  const cdnDomain = process.env.REACT_APP_CDN_DOMAIN

  return (
    <div id='kt_app_header' className='app-header'>
      <div
        id='kt_app_header_container'
        className={clsx(
          'app-container flex-lg-grow-1',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
      >
        {config.app.sidebar?.display && (
          <>
            <div
              className='d-flex align-items-center d-lg-none ms-n2 me-2'
              title='Show sidebar menu'
            >
              <div
                className='btn btn-icon btn-active-color-primary w-35px h-35px'
                id='kt_app_sidebar_mobile_toggle'
              >
                <KTIcon iconName='abstract-14' className=' fs-1' />
              </div>
              <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
                <Link to='/dashboard' className='d-lg-none'>
                  {/* Mobile Logo (Sidebar Toggle) */}
                   <img
                    alt='Logo Mobile'
                    src={`${cdnDomain}/company/logo-2.png`}
                    className='h-25px d-md-none mb-1'
                  />
                   {/* Tablet/Desktop Logo (Sidebar Toggle) */}
                  <img
                    alt='Logo'
                    src={`${cdnDomain}/company/logo.png`}
                    className='h-30px d-none d-md-inline'
                  />
                </Link>
              </div>
            </div>
          </>
        )}

        {!(config.layoutType === 'dark-sidebar' || config.layoutType === 'light-sidebar') && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
            <Link to='/dashboard'>
              {config.layoutType !== 'dark-header' ? (
                <>
                  {/* Mobile Logo */}
                  <img
                    alt='Logo Mobile'
                    src={`${cdnDomain}/company/logo-2.png`}
                    className='h-25px d-md-none mb-1 app-sidebar-logo-default'
                  />
                  {/* Desktop Logo */}
                  <img
                    alt='Logo'
                    src={`${cdnDomain}/company/logo.png`}
                    className='h-30px d-none d-md-inline app-sidebar-logo-default'
                  />
                </>
              ) : (
                <>
                  {/* Mobile Logo (Light) */}
                  <img
                    alt='Logo Mobile'
                    src={`${cdnDomain}/company/logo-2.png`}
                    className='h-25px d-md-none mb-1 app-sidebar-logo-default theme-light-show'
                  />
                  {/* Desktop Logo (Light) */}
                  <img
                    alt='Logo'
                    src={`${cdnDomain}/company/logo.png`}
                    className='h-30px d-none d-md-inline app-sidebar-logo-default theme-light-show'
                  />
                  {/* Mobile Logo (Dark) */}
                  <img
                    alt='Logo Mobile'
                    src={`${cdnDomain}/company/logo-2.png`}
                    className='h-25px d-md-none mb-1 app-sidebar-logo-default theme-dark-show'
                  />
                  {/* Desktop Logo (Dark) */}
                  <img
                    alt='Logo'
                    src={`${cdnDomain}/company/logo.png`}
                    className='h-30px d-none d-md-inline app-sidebar-logo-default theme-dark-show'
                  />
                </>
              )}
            </Link>
          </div>
        )}

        <div
          id='kt_app_header_wrapper'
          className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'
        >
          {config.app.header.default?.content === 'menu' &&
            config.app.header.default.menu?.display && (
              <div
                className='app-header-menu app-header-mobile-drawer align-items-stretch'
                data-kt-drawer='true'
                data-kt-drawer-name='app-header-menu'
                data-kt-drawer-activate='{default: true, lg: false}'
                data-kt-drawer-overlay='true'
                data-kt-drawer-width='225px'
                data-kt-drawer-direction='end'
                data-kt-drawer-toggle='#kt_app_header_menu_toggle'
                data-kt-swapper='true'
                data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
              >
                <Header />
              </div>
            )}
          <Navbar />
        </div>
      </div>
    </div>
  )
}
